export function StarIconV2() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
    >
      <path
        d="M8 1l2.5 5 5.5.5-4 4 1 5.5L8 13l-5 3.5 1-5.5-4-4 5.5-.5L8 1z"
        fill="#FFC31D"
      />
    </svg>
  );
}
